export default __webpack_public_path__ + "static/media/(85).831a62da.jpg";